export const SET_PAGE_SIZE = 'SET_PAGE_SIZE'
export const SET_SEARCH_TERM = 'SET_SEARCH_TERM'
export const SET_SORT_DIR = 'SET_SORT_DIR'
export const SET_ORDER_BY = 'SET_ORDER_BY'
export const SET_FILTER_OPTIONS = 'SET_FILTER_OPTIONS'
export const SET_FILTER_BY = 'SET_FILTER_BY'
export const SET_LOCATION_TREE = 'SET_LOCATION_TREE'
export const SET_NETWORK_TREE = 'SET_NETWORK_TREE'
export const SET_LOCATIONS = 'SET_LOCATIONS'
export const SET_LOCATION = 'SET_LOCATION'
export const SET_LOCATIONS_FOUND = 'SET_LOCATIONS_FOUND'
export const SET_PREFERENCES = 'SET_PREFERENCES'
export const UPDATE_PREFERENCE = 'UPDATE_PREFERENCE'
export const RESET_PREFERENCE_CHANGE = 'RESET_PREFERENCE_CHANGE'
export const RESET_PREFERENCES = 'RESET_PREFERENCES'
export const PUSH_LOCATION = 'PUSH_LOCATION'
export const POP_LOCATION = 'POP_LOCATION'
export const SET_INSURANCE_FOUND = 'SET_INSURANCE_FOUND'
export const SET_INSURANCE = 'SET_INSURANCE'
export const PUSH_INSURANCE = 'PUSH_INSURANCE'
export const POP_INSURANCE = 'POP_INSURANCE'
export const SET_INSURANCE_DATA = 'SET_INSURANCE_DATA'

export const RESET_SEARCH = 'RESET_SEARCH'
export const RESET_PROVIDERS = 'RESET_PROVIDERS'
export const SET_PROVIDER_FOUND = 'SET_PROVIDER_FOUND'
export const SET_PROVIDERS = 'SET_PROVIDERS'
export const PUSH_PROVIDER = 'PUSH_PROVIDER'
export const POP_PROVIDER = 'POP_PROVIDER'
export const SET_PROVIDER_DATA = 'SET_PROVIDER_DATA'
export const SET_FOUNDPROVIDER_DATA = 'SET_FOUNDPROVIDER_DATA'

export const RESET_ADD_LOCATION = 'RESET_ADD_LOCATION'
export const SET_ADD_LOCATION = 'SET_ADD_LOCATION'
export const SET_FOUND_LOCATIONS = 'SET_FOUND_LOCATIONS'
export const RESET_PRICING = 'RESET_PRICING'
export const SET_PRICING = 'SET_PRICING'

export const SET_PROVIDER_PROFILE = 'SET_PROVIDER_PROFILE'
export const SET_PROVIDER_REVIEWS = 'SET_PROVIDER_REVIEWS'
export const RESET_PROVIDER_PROFILE = 'RESET_PROVIDER_PROFILE'

export const LOCATIONS_SEARCH_TERM = 'LOCATIONS_SEARCH_TERM'
export const LOCATIONS_PAGE_SIZE = 'LOCATIONS_PAGE_SIZE'
export const LOCATIONS_SORT_DIR = 'LOCATIONS_SORT_DIR'
export const LOCATIONS_ORDER_BY = 'LOCATIONS_ORDER_BY'
export const LOCATIONS_FILTER_BY = 'LOCATIONS_FILTER_BY'



// WEBPACK FOOTER //
// ./src/store/modules/locations/types.js